import React, { useContext, useRef } from 'react';
import { IVideosContext, VideosContext } from '../../../videosState/videosContext';
import Text from 'components/Text/Text';
import { IGetVideoStudiosShort } from 'types';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { getVideoStudiosShortInfo } from 'backend/videos';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { useTranslation } from 'react-i18next';
import style from './StudioSelect.module.scss';

const { Option } = Select;

const StudioSelect: React.FC = () => {
	const { setStudio, selectedStudio } = useContext<IVideosContext>(VideosContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetVideoStudiosShort, void>(
		getVideoStudiosShortInfo,
	);
	const { t } = useTranslation('listing');

	const value = !loading ? selectedStudio : undefined;

	return (
		<div className={style.container} data-test="StudioSelect">
			<Text translationNameSpace="listing" translationKey="studioLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setStudio}
				value={value}
				loading={loading}
				disabled={loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				allowClear={true}
				removeIcon={false}
				listItemHeight={response?.data.videoStudios.length}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{response?.data.videoStudios.map((el) => (
						<Option className={style.listItem} value={el.id} key={el.id}>
							{el.name}
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default StudioSelect;
